<template>
	<el-dialog v-model="innerVisible" title="新建单据" width="92%"  custom-class="zero-padding-modal" 
	@open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>
			<div class="assemble-edit-modal-content">					
				<div class="" style="margin: 30px 60px 10px 60px;">
					<el-form :model="createOrderParams" label-width="">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="品名:">
                                <el-input v-model="createOrderParams.PurchaseName" clearable placeholder="请输入品名" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" class="marginleft">
                            <el-form-item label="品号:">
                                <el-input v-model="createOrderParams.PurchaseCode" clearable placeholder="请输入品号" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" class="marginleft">
                            <el-form-item label="规格型号:">
                                <el-input v-model="createOrderParams.specificationModel" clearable
                                    placeholder="请输入规格型号" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="marginleft">
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search"
                                    @click="getModifyInitData">提交</el-button>
                                <el-button icon="el-icon-refresh-right" @click="selfClose">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
				</div> 					
				<div style="flex-grow: 1;height:1px;overflow:auto;">
                    <el-table :data="list" border style="width: 100%;" height="600" :header-cell-style="rowClass" row-key="code" ref="TableRef"
                        @selection-change="handleSelectionChange" :default-sort="{ prop: 'isCheck', order: 'ascending' }" v-loading="isLoading">
                        <el-table-column align="center" width="60" type="selection" reserve-selection :selectable="selectableFunction" />
                        <el-table-column label="项目编号" align="center" prop="projectCode" width="120" />
                        <el-table-column label="序号" align="center" prop="xuHao" />
                        <el-table-column label="主件品号" align="center" prop="mainCode" width="120" />
                        <el-table-column label="品名" align="center" prop="name" width="160" />
                        <el-table-column label="品号" align="center" prop="code" width="120" />
                        <el-table-column label="规格型号" align="center" width="250" sortable prop="specificationModel" />
                        <el-table-column label="单位" align="center">
                            <template #default="scope">
                                <span>{{ scope.row.unit }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="检验方式" align="center">
                            <template #default="scope">
                                <span>
                                    {{ getInspectionMethod(scope.row.inspectionMethod) }}
                                </span>
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column label="品牌名称" align="center" prop="brandName" width="160" /> -->
                        <el-table-column label="是否结束" align="center" prop="isEnd" width="160" />
                        <el-table-column label="采购数量" align="center" prop="purchaseNumber" />
                        <el-table-column label="已推ERP数" align="center" prop="erpDeliveryQuantity" />
                        <el-table-column label="本次发货数量" align="center" width="160">
                            <template #default="scope">
                                <el-input-number min="0" class="edit-pipeline" v-model.number="scope.row.deliveryQuantity"
                                    :mix="scope.row.deliveryQuantity" size="small">
                                </el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <Pagination :total="tableDataItems" v-model:page="createOrderParams.PageNo"
                        v-model:limit="createOrderParams.PageSize" @pagination="getModifyInitData"
                        style="margin-top: 20px; text-align: center"></Pagination> -->
                    <!-- <div style="display:flex;justify-content:flex-end;padding-top: 8px;">
                        <el-pagination 
                            :background="true" 
                            :total="tableDataItems" 
                            v-model:current-page="createOrderParams.PageNo" 
                            v-model:page-size="createOrderParams.PageSize"
                            layout="total, sizes, prev, pager, next, jumper" 
                            @size-change="sizeChange" 
                            @current-change="currentChange" 
                        />
                    </div> -->
                </div>		
			</div>			
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<!-- <el-button type="primary" @click="onComfirm">提 交</el-button> -->
				<el-button type="primary" @click="confirmNewDeliveryOrder">提 交</el-button>
				
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, reactive, ref, watch, toRefs } from 'vue'	
//import EditModal from './editModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getCreatingShipOrderPage, systemDeNo,secondJundgment } from '@/service/main/supplier/index'
import { testockType ,department,location,page ,RestockOrderAdd,getCreatingPage,CORFIRMCREATES} from '@/service/main/invoices/buildGoods'
//import { localStatus } from '../../switchCase'
//rules
const formRules = {
	department: [{ required: true, message: '部门编号不能为空', trigger: 'blur' }],
    restockType: [{ required: true, message: '进货单别不能为空', trigger: 'blur' }],
    purchaseType: [{ required: true, message: '采购单别不能为空', trigger: 'blur' }],
    purchaseNo: [{ required: true, message: '采购单号不能为空', trigger: 'blur' }],
}
const emits = defineEmits(['update:visible','loadInitData','callback'])
const widthmd = ref(4)
const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	info:{
		type:Object,
		default:()=>{
			return {}
		}
	}
})
const { visible, info } = toRefs(props)

const innerVisible = ref(false)
const isLoading = ref(false)

const chooseVisieble = ref(false)
const list = ref([])
const tableDataDrawer = ref([])
const tableDataItems = ref(0)
const query = ref({})
const selectOptions = reactive({
	testockTypeData:[],
	departmentData:[]
})

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}
const TableRef = ref();
const selfClose = function(){    
    TableRef.value.clearSelection()
	list.value = []
    checkRows.value = []
	infoList.value = []
	createOrderParams.value = {}
	createOrderParams.PageSize = 10000
	createOrderParams.PageNo = 1
	saveData.value = {}
	info.value = {}
	innerVisible.value = false
    isLoading.value = false
}
// 查询新建送货单列表数据接口参数定义
const createOrderParams = reactive({
    PurchaseID: 0,
    DeliveryNo: "",
    PurchaseName: "",
    PurchaseCode: "",
    specificationModel: "",
    PageNo: 1,
    PageSize: 10000
})
// 定义新建送货单中选中的数据
const checkRows = ref([])
// 送货单明细多选方法
const handleSelectionChange = (val) => {
    // val.forEach((item:any)=>{
    //     checkRows.value.push(item)
    // })
    console.log('val',val)
    checkRows.value = val
    console.log('checkRows.value',checkRows.value)
}
const dialogRef = ref()
const onComfirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
			console.log('valid',valid)
			confirm((f)=>{
				if (f) {
					ElMessage.success("操作成功")
					selfClose()
					emits('callback')
				}
			})

        }
      })
	// let f = checkBeforeSubmit()
	// if (!f) return flase
	
}

const openedInit = function(){
    isLoading.value = true
	getModifyInitData()
	//gettestockType()
	//getdepartment()
}

const getModifyInitData = function(){
	// let para = {
	// 		TC001:info.value.purchaseType,
	// 		TC002:info.value.purchaseNo
	// 	}	
	// emits('loadInitData',para,function(f,d){
	// 	if (f) {
	// 		query.value = d.data
	// 		console.log('query.value',query.value)
	// 		list.value = (d.data.restockOrderDetails || []).map((obj,index)=>{
	// 			obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
	// 			return obj
	// 		})
	// 	}
	// })	
	createOrderParams.PurchaseID = info.value.PurchaseID
	createOrderParams.DeliveryNo = info.value.DeliveryNo
	// getCreatingPage(createOrderParams).then((res) => {		
    //     const { data } = res
    //     data.rows.map(item=> {
    //         item.db = false
    //         return item
    //     })
    //     list.value = res.data.rows
    //     tableDataItems.value = data.totalRows
    // })
    getCreatingPage(createOrderParams).then((res) => {		
        const { data } = res
        data.map(item=> {
            item.db = false
            return item
        })
        list.value = res.data
        isLoading.value = false
    })
}
const sizeChange = function(pageSize){
	// createOrderParams.PageNo = 1
	createOrderParams.PageSize = pageSize
	getModifyInitData()
}

const currentChange = function(page){
	createOrderParams.PageNo = page
	getModifyInitData()
}
// 禁止选择项
// 新增/修改弹框数量为0不可选择
const selectableFunction = (row) => {
    if (row.isCheck == false) {
        return true
    } else {
        return false
    }
}
// 定义新建送货单接口参数
const saveData = reactive({
    PurchaseID: 0,
	DeliveryNo: "",
    deliveryType: "",
    goodsDeliveryDetailsInputList: []
    //goodsDeliveryDetailsInputList: [] as { projectCode: string, code: string, name: string, specificationModel: string, long: number, high: number, width: number, weight: number, unit: string, minUnit: string, deliveryQuantity: number, goodsDeliveryId: number,purchaseNo :string, PurchaseType: string}[]
})
// 新建送货单确定

const confirmNewDeliveryOrder = () => {    
    if(checkRows.value.length!==0){
        saveData.PurchaseID = info.value.PurchaseID
        saveData.DeliveryNo = info.value.DeliveryNo
        saveData.goodsDeliveryDetailsInputList = []
        saveData.goodsDeliveryDetailsInputList = checkRows.value//.filter((scope) => scope.deliveryQuantity <= scope.purchaseNumber - scope.outdeliveryQuantity)
        console.log('saveData',saveData.goodsDeliveryDetailsInputList)
        //if (saveData.goodsDeliveryDetailsInputList.length == checkRows.value.length) {
            ElMessageBox.confirm("是否确认新建送货单？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                isLoading.value = true
                //console.log('saveData',saveData)
                CORFIRMCREATES(saveData).then((res) => {				
                    ElMessage.success("新建送货单成功");
                    selfClose()
                })
                // selfClose()
            }).catch(() => {
                ElMessage.info("已取消删除");
                selfClose()
            })
        //} else {
            ElMessage.warning("请检查本次发货数量是否准确")
        //}
    }else{
        ElMessage.warning("请选择物料")
    }
	
}

const infoList = ref([])


const confirm= function(callback){
	query.value.restockOrderDetails = infoList
	//console.log('query',query.value)
	CORFIRMCREATES(query.value).then((res) => {
	callback && callback(true)
	}).catch(()=>{
		callback && callback(false)
	})
}
const getreset= ()=>{
    checkRows.value = []
    TableRef.value.clearSelection()
}

</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 75vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 12px 16px;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
    .marginleft {
        margin-left: 20px
    }
}
</style>